  import React, { useState } from 'react';

  const BoxPropertyDetail = ({ about}) => {
   

    return (
      <div>
        <div className="wg-property box-property-detail">
          <div className="wg-title text-11 fw-6 text-color-heading">
            Property Details
          </div>
          <div className="content">
            <p className="description text-1">
            {about || 'No data available'}
            </p>
            {/* {aboutLines.length > 5 && (
              <button 
                className="tf-btn-link style-hover-rotate read-more-btn" 
                onClick={() => setExpanded(!expanded)}
              >
                <span>{expanded ? "Read Less" : "Read More"}</span>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clipPath="url(#clip0_2348_5612)">
                    <path
                      d="M1.66732 9.99999C1.66732 14.6024 5.39828 18.3333 10.0007 18.3333C14.603 18.3333 18.334 14.6024 18.334 9.99999C18.334 5.39762 14.603 1.66666 10.0007 1.66666C5.39828 1.66666 1.66732 5.39762 1.66732 9.99999Z"
                      stroke="#F1913D" strokeWidth="1.5" strokeLinecap="round"
                    />
                    <path d="M10 6.66666L10 13.3333" stroke="#F1913D" strokeWidth="1.5" strokeLinecap="round" />
                    <path d="M6.66732 10L10.0007 13.3333L13.334 10" stroke="#F1913D" strokeWidth="1.5" strokeLinecap="round" />
                  </g>
                  <defs>
                    <clipPath id="clip0_2348_5612">
                      <rect width="20" height="20" fill="white" transform="translate(20) rotate(90)" />
                    </clipPath>
                  </defs>
                </svg>
              </button>
            )} */}
          </div>
        </div>
      </div>
    );
  };

  export default BoxPropertyDetail;
